import { useTranslation } from "react-i18next"

import ingeteamev from "../../../data/home/ingeteamev/videoSliderData.json"
import { getCmsAssetsUrl } from "../../../helpers/general"
import { getSiteConfig } from "../../../hooks/use-site-config"
import ListOfSlides from "../../ListOfSlides/ListOfSlides"

const assetsUrl = getCmsAssetsUrl()
const fixSrc = src => src.replace(/^\/data/, assetsUrl)

export default function VideoSlider() {
  const { t } = useTranslation()
  const site = getSiteConfig()
  const slidersMap = {
    ingeteamev: ingeteamev,
  }

  // Traduce títulos y descripciones usando t()
  const translatedSlides = slidersMap[site.code].map(slide => ({
    ...slide,
    title: t(`videoBanner.${slide.code}.title`),
    description: t(`videoBanner.${slide.code}.description`),
    media: {
      ...slide.media,
      src: fixSrc(slide.media.src),
      alt: t(slide.media.alt),
    },
    mobilemedia: {
      ...slide.mobilemedia,
      src: fixSrc(slide.mobilemedia.src),
      alt: t(slide.mobilemedia.alt),
    },
    poster: slide.poster ? { ...slide.poster, src: fixSrc(slide.poster.src) } : slide.poster,
  }))

  return (
    <ListOfSlides
      slides={translatedSlides}
      textOverImage={false}
      videoAutoplayChain={true}
      controls={false}
    />
  )
}
